<div id="card-benefit-div-1-{{benefit.id}}" class="container-card" (click)="goToDetailBenefit()">
  <div id="card-benefit-div-2-{{benefit.id}}" class="container-image">
    <img id="card-benefit-img-1-{{benefit.id}}"  class="benefit-imagen" [ngClass]="{'imgCards': !benefitIsPlan()} "[src]="benefit.image" alt=""/>
  </div>
  <div id="card-benefit-div-3-{{benefit.id}}" class="d-flex align-items-start justify-content-between label-header-container"
    [ngClass]="{ 'container-flexend': !benefit.isCopec }">
    <div id="card-benefit-div-4-{{benefit.id}}" *ngIf="benefit.isCopec" class="p-1 container-label-copec">
      <img id="card-benefit-img-2-{{benefit.id}}"  src="/assets/img/copec-label.svg" alt=""/>
    </div>
    <i id="card-benefit-i-1-{{benefit.id}}" class="m-1 fa-regular fa-bookmark"></i>
  </div>
  <div id="card-benefit-div-5-{{benefit.id}}" *ngIf="benefit.isNewBenefit" class="d-flex align-items-center label-footer-container">
    <span id="card-benefit-spam-1-{{benefit.id}}" class="copec-bold-14">{{ benefit.textLabel }}</span>
  </div>
  <div id="card-benefit-div-6-{{benefit.id}}" class="p-3 d-flex flex-column container-description">
    <span id="card-benefit-spam-2-{{benefit.id}}" class="benefit-title copec-rg-16" [ngClass]="benefit.title.length >= 80 ? '':'benefit-height'">{{ benefit.title.length >= 80 ? benefit.title.slice(0, 77)+'...' : benefit.title }}</span>
    <span id="card-benefit-spam-3-{{benefit.id}}" class="benefit-description copec-lg-14" [ngClass]=" benefit.description.length >= 140  ? '':'benefit-height-description'">{{ benefit.description.length >= 140 ? benefit.description.slice(0, 137)+'...' : benefit.description}} </span>
    <div class="d-flex align-items-center">
      <i *ngFor="let s of arrStar"
           id="card-benefit-i-2-{{benefit.id}}"
           class = 'far fa'
            [ngClass]="s <= averageStar() ? 'fa-solid fa-star' : 'fa-regular fa-star'"
      ></i>

      <span id="card-benefit-spam-4-{{benefit.id}}" class="ms-2 copec-rg-12">{{benefit.average}} ({{benefit.totalStars}}) </span>
    </div>
  </div>
</div>
